export default __webpack_public_path__ + "static/anachrony-balthazaurus-scroll-20e7caaa83f2ed63d63cc09a2010a4f6.gif";